import type { RouteObject } from 'react-router';

import { loginRoute } from './login/login.route';
import { otpVerifyRoute } from './otp-verify/otp-verify.route';
import { recoverRoute } from './recover/recover.route';

/**
 * The three pre-session screens, aggregated — `.routes.tsx` plural, because the
 * feature exports more than one `RouteObject`.
 *
 * They sit **outside** the console layout route and outside its guard. Every
 * one of them is a screen the guard redirects *to*, so running the chain on
 * them would loop, and every control the console chrome carries assumes a
 * session that does not exist yet.
 */
export const authRoutes: RouteObject[] = [loginRoute, otpVerifyRoute, recoverRoute];
